export default function ($) {
  var set_top_position = function(e) {
    var body_height = e.parent('.timeline-elements').siblings('.timeline-body').height(),
        top_position = parseFloat( body_height / 2 );
    e.css('top', top_position);
  };
  if( $(window).width() < 640 ) {
    $('.js-timeline-element-dot').each( function() {
      set_top_position($(this));
    });
  } else {
    $('.js-timeline-element-dot').each( function() {
      $(this).css('top', '50%');
    });
  }

  $(window).on('resize', function() {
    if( $(window).width() < 640 ) {
      $('.js-timeline-element-dot').each( function() {
        set_top_position($(this));
      });
    } else {
      $('.js-timeline-element-dot').each( function() {
        $(this).css('top', '50%');
      });
    }
  });
};
